
/**
 * Given a value in cents, return a formatted money string.
 * If the value is 0, return the string 'FREE'
 *
 * @example
 *
 * Input:   formatMoney(123456)
 * Output:  $1,234.56
 *
 * @param amount: number - the value in cents
 */
export const formatMoney = (amount: number): string => {
  if (amount === 0) {
    return 'FREE'
  }

  return `$${(amount / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
}
